// o Sentry primeiro, para pegar até os erros do carregamento dos outros módulos
import { reactRootOptions } from './monitoring.js';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { installErrorLog } from './errorLog.js';
import { watchMonitoringContext } from './monitoringContext.js';
import { installMobileMode } from './ui/mobile.js';
import './styles.css';
import './ui/theme.css';
import './ui/mobile.css';

installErrorLog();
watchMonitoringContext();
// o modo celular antes de desenhar: o primeiro quadro já sai na forma certa
installMobileMode();

const container = document.getElementById('root');
if (!container) throw new Error('elemento #root não encontrado');

createRoot(container, reactRootOptions()).render(<App />);
